import { create } from 'apisauce';

const api = create( {
  baseURL: 'https://ipapi.co/',
  headers: { Accept: '*/*' },
} );

export default {
  getClientPublicIP( ) {
    return api.get( 'ip/' );
  },
};
